<template>
  <el-form-item :label="label">
    <ul>
      <li v-for="item in ProxyTypeLabels" :key="item.proxyType">
        <el-checkbox
          :checked="modelValue.includes(item.proxyType)"
          :disabled="disabled"
          @update:modelValue="input($event, item.proxyType)"
        >
          {{ item.label }}
        </el-checkbox>
      </li>
    </ul>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ProxyType, ProxyTypeLabels } from '@/api/types'

export default defineComponent({
  name: 'BlockedProxyTypes',
  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const input = (isOn: boolean, proxy: ProxyType) => {
      if (isOn) {
        const addedProxy = [...props.modelValue, proxy]
        context.emit('update:modelValue', Array.from(new Set(addedProxy)))
      } else {
        const removedProxy = props.modelValue.filter((item) => item !== proxy)
        context.emit('update:modelValue', Array.from(new Set(removedProxy)))
      }
    }

    return { input, ProxyTypeLabels }
  }
})
</script>
<style scoped lang="scss">
:deep(ul) {
  list-style: none;
  padding: 0;
}
</style>
